import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { IAPISellerGrid } from "../interfaces";
import { AddressModel } from "./AddressModel";
import { CreateSellerModel } from "./SellerModels";
import { StateModel } from "./CountryModels";

export class SellerGridModel {
  id: string;
  name: string;
  used: boolean;
  createdDate: Date;
  address: AddressModel;
  isActive: boolean;

  constructor(data?: Partial<SellerGridModel>) {
    this.id = data?.id || "";
    this.name = data?.name || "";
    this.used = data?.used || false;
    this.createdDate = data?.createdDate || new Date();
    this.address = data?.address
      ? new AddressModel(data.address)
      : new AddressModel();
    this.isActive = data?.isActive ?? true;
  }

  static deserializeAPIModel(data: IAPISellerGrid) {
    const mappedData: Partial<SellerGridModel> = {
      id: data.id,
      name: data.name,
      used: data.used,
      createdDate: UtilityMethods.removeZFromDateString(data.createdDate),
      address: data.address
        ? AddressModel.deserializeAPIModel(data.address)
        : new AddressModel(),
      isActive: data.isActive,
    };
    return new SellerGridModel(mappedData);
  }

  static deserializeFromUpsertModel(data: CreateSellerModel) {
    const state = data.countryDetails?.states?.find(
      (state) => state.id === data.state
    );
    const mappedData: Partial<SellerGridModel> = {
      id: data.id,
      name: data.name,
      used: false,
      createdDate: new Date(),
      address: new AddressModel({
        address1: data.address1,
        address2: data.address2,
        city: data.city,
        countryDetails: data.countryDetails,
        country: data.countryDetails?.name,
        countryCode: data.countryDetails?.code?.toString() || "",
        state: new StateModel({
          id: data.state,
          name: state?.name || "",
        }),
        zipCode: data.zip,
      }),
      isActive: true,
    };
    return new SellerGridModel(mappedData);
  }
}
